
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/base/SEOHead';
import HeroSection from './components/HeroSection';
import IntroSection from './components/IntroSection';
import ImportanceSection from './components/ImportanceSection';
import ApproachSection from './components/ApproachSection';
import HazardIdentificationSection from './components/HazardIdentificationSection';
import TrainingRequirementsSection from './components/TrainingRequirementsSection';
import OnboardingSection from './components/OnboardingSection';
import RetrainingSection from './components/RetrainingSection';
import FatalFourSection from './components/FatalFourSection';
import TechnicalTrainingSection from './components/TechnicalTrainingSection';
import IndustrySpecificSection from './components/IndustrySpecificSection';
import FlexibleSolutionsSection from './components/FlexibleSolutionsSection';
import SpecializedServicesSection from './components/SpecializedServicesSection';
import LocationsSection from './components/LocationsSection';
import CommitmentSection from './components/CommitmentSection';
import ContactFormSection from './components/ContactFormSection';

const OSHATrainingPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead 
        title="OSHA Training Programs - HP Inc Consulting Services | Safety Training Experts"
        description="Comprehensive OSHA training programs and safety certification courses. Expert-led training for construction, industrial, and workplace safety compliance in New York, New Jersey, Pennsylvania, Connecticut, Maryland, and Boston."
        keywords="OSHA training, safety training programs, OSHA certification, workplace safety training, construction safety training, industrial safety training, OSHA 10 hour training, OSHA 30 hour training, safety compliance training, New York safety training"
        canonical="https://hpincconsultant.com/osha-training"
        ogTitle="OSHA Training Programs - Professional Safety Training Services"
        ogDescription="Expert OSHA training programs and safety certification courses for construction and industrial workers. Comprehensive training solutions across the Northeast."
        ogUrl="https://hpincconsultant.com/osha-training"
      />
      <Header />
      <main>
        <HeroSection />
        <IntroSection />
        <ImportanceSection />
        <ApproachSection />
        <HazardIdentificationSection />
        <TrainingRequirementsSection />
        <OnboardingSection />
        <RetrainingSection />
        <FatalFourSection />
        <TechnicalTrainingSection />
        <IndustrySpecificSection />
        <FlexibleSolutionsSection />
        <SpecializedServicesSection />
        <LocationsSection />
        <CommitmentSection />
        <ContactFormSection />
      </main>
      <Footer />
    </div>
  );
};

export default OSHATrainingPage;
